import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  LAUNCH_DARKLY_CLIENT_ID,
  LAUNCH_DARKLY_CONTEXT,
  LaunchDarklyContext,
} from '../types/feature-flags.types';
import { FeatureFlagService } from './feature-flag.service';

export interface FeatureFlagModuleConfig {
  clientId:
    | string
    | {
        useFactory: (...deps: never[]) => Observable<string>;
        deps?: unknown[];
      };
  config: {
    useFactory: (...deps: never[]) => Observable<LaunchDarklyContext>;
    deps?: unknown[];
  };
}

@NgModule({
  imports: [],
  providers: [FeatureFlagService],
})
export class FeatureFlagModule {
  static setup(
    config: FeatureFlagModuleConfig
  ): ModuleWithProviders<FeatureFlagModule> {
    const providers: Provider[] = [];
    if (typeof config.clientId === 'string') {
      providers.push({
        provide: LAUNCH_DARKLY_CLIENT_ID,
        useValue: of(config.clientId),
      });
    } else if (typeof config.clientId === 'object') {
      providers.push({ ...config.clientId, provide: LAUNCH_DARKLY_CLIENT_ID });
    }
    providers.push({
      ...config.config,
      provide: LAUNCH_DARKLY_CONTEXT,
    });

    return {
      ngModule: FeatureFlagModule,
      providers,
    };
  }
}
